module.exports = __webpack_public_path__ + "static/media/qc-default-logo.e03796c8.png";